import R from 'ramda'

import {
  ACTIONS,
  METHODS,
  AUTH_API_URL
} from '../constants'

const getBaseUrlFromStatePath = statePath => `${AUTH_API_URL}/${statePath[1]}`

const single = {
  type: ACTIONS.FETCH_ONE.START,
  actionSet: ACTIONS.FETCH_ONE
}

const list = {
  type: ACTIONS.FETCH_LIST.START,
  actionSet: ACTIONS.FETCH_LIST
}

const getList = R.merge(list, {method: METHODS.GET})

const deleteOne = R.merge(single, {method: METHODS.DELETE})
const postOne = R.merge(single, {method: METHODS.POST})
const patchOne = R.merge(single, {method: METHODS.PATCH})
const getOne = R.merge(single, {method: METHODS.GET})

export const parts = {
  getList,
  getOne,
  deleteOne,
  patchOne,
  postOne
}

export const createOne = (
  statePath,
  payload = {}
) => R.merge(getOne, {
  url: getBaseUrlFromStatePath(statePath),
  statePath,
  payload
})

export const modifyOne = ({
  statePath,
  _id,
  payload = {}
}) => R.merge(patchOne, {
  url: getBaseUrlFromStatePath(statePath) + `/${_id}`,
  _id, // : userId,
  statePath,
  payload
})

// deactivation sets the STATUS on an item to not_active
export const deactivateOne = ({
  statePath,
  _id
}) => R.merge(deleteOne, {
  url: getBaseUrlFromStatePath(statePath) + `/${_id}`,
  _id,
  statePath
})

// remove, as opposed to deactive, removes the item from the DB
// completely
export const removeOne = ({
  statePath,
  _id,
  pageNum = 1,
  perPage = 20
}) => R.merge(list, {
  url: getBaseUrlFromStatePath(statePath) + `/${_id}/forgood`,
  method: METHODS.DELETE,
  statePath,
  query: {
    pageNum,
    perPage
  }
})

export const fetchOne = ({
  statePath,
  _id
}) => R.merge(getOne, {
  url: getBaseUrlFromStatePath(statePath) + `/${_id}`,
  _id, // : userId
  statePath
})

export const fetchList = ({
  statePath,
  query
}) => R.merge(getList, {
  url: getBaseUrlFromStatePath(statePath),
  statePath,
  query // : {pageNum, perPage, ids || term}
});

export const fetchAutocompleteSuggestions = ({
  statePath,
  term,
  pageNum = 1
}) => ({
  type: ACTIONS.AUTOCOMPLETE.START,
  actionSet: ACTIONS.AUTOCOMPLETE,
  method: METHODS.GET,
  url: getBaseUrlFromStatePath(statePath),
  query: {
    term,
    pageNum
  },
  statePath
})

export const setAutocompleteSelections = ({
  statePath,
  selections,
  onSuccessAction
}) => ({
  type: ACTIONS.AUTOCOMPLETE.SET_SELECTIONS,
  statePath,
  selections,
  onSuccessAction: onSuccessAction || {
    type: ACTIONS.NAVIGATION.GO_TO,
    pageName: statePath[1],
    pageNum: 1,
    perPage: 20,
    ids: selections.map(s => s._id)
  }
})

export const clearAutocompleteSuggestions = ({
  statePath
}) => ({
  type: ACTIONS.AUTOCOMPLETE.CLEAR_SUGGESTIONS,
  statePath
})

export const addNote = ({
  _id,
  statePath,
  payload = {}
}) => R.merge(postOne, {
  url: getBaseUrlFromStatePath(statePath) + `/${_id}/notes`,
  _id,
  statePath,
  payload
})

export const removeNote = ({
  statePath,
  _id,
  noteId
}) => R.merge(deleteOne, {
  url: getBaseUrlFromStatePath(statePath) + `/${_id}/notes/${noteId}`,
  _id,
  statePath
})

export const removeAPIToken = ({
  statePath,
  _id,
  tokenId
}) => R.merge(list, {
  url: getBaseUrlFromStatePath(statePath) + `/${encodeURIComponent(tokenId)}`,
  method: METHODS.DELETE,
  statePath,
  query: {}
})
export const regenerateAPIToken = ({
  statePath,
  _id,
  tokenId
}) => R.merge(patchOne, {
  url: getBaseUrlFromStatePath(statePath) + `/${encodeURIComponent(tokenId)}`,
  _id,
  statePath
});



// WEBPACK FOOTER //
// ./webAdmin/actions/page.js